{
  "base": {
    "article": "artikkelen",
    "flash": "flashen",
    "timeless": "den tidløse",
    "draft": {
      "title": "Utkast",
      "description": "Du jobber med et utkast av {{label}}",
      "transitions": {
        "done": {
          "title": "Legg klar",
          "description": "Legg {{label}} som klar",
          "promptTitle": "Legg klar {{label}}"
        },
        "approved": {
          "title": "Godkjenn",
          "description": "Godkjenn {{label}} for publisering",
          "promptTitle": "Godkjenn {{label}}"
        },
        "usable": {
          "title": "Publiser",
          "description": "Publiser {{label}}",
          "promptTitle": "Publiser {{label}}"
        },
        "withheld": {
          "title": "Planlegg publisering",
          "description": "Angi tid for publisering. Flytt oppdrag/plan om en annen dato ønskes.",
          "promptTitle": "Planlegg publisering av {{label}}"
        }
      }
    },
    "done": {
      "title": "Klar",
      "description": "{{label, capitalize}} er klar og venter på godkjenning",
      "transitions": {
        "approved": {
          "title": "Godkjenn",
          "description": "Godkjenn {{label}} for publisering",
          "promptTitle": "Godkjenn {{label}}"
        },
        "usable": {
          "title": "Publiser",
          "description": "Publiser {{label}} direkte",
          "promptTitle": "Publiser {{label}}"
        },
        "withheld": {
          "title": "Planlegg publisering",
          "description": "Angi tid for publisering. Flytt oppdrag/plan om en annen dato ønskes.",
          "promptTitle": "Planlegg publisering av {{label}}"
        },
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om {{label}} til et utkast igjen",
          "promptTitle": "Gjør om {{label}} til utkast"
        },
        "unpublished": {
          "title": "Avpubliser",
          "description": "Avbryt og arkiver {{label}}",
          "promptTitle": "Avpubliser {{label}}"
        }
      }
    },
    "approved": {
      "title": "Godkjent",
      "description": "{{label, capitalize}} er godkjent for publisering",
      "transitions": {
        "usable": {
          "title": "Publiser",
          "description": "Publiser {{label}}",
          "promptTitle": "Publiser {{label}}"
        },
        "withheld": {
          "title": "Planlegg publisering",
          "description": "Angi tid for publisering. Flytt oppdrag/plan om en annen dato ønskes.",
          "promptTitle": "Planlegg publisering av {{label}}"
        },
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om {{label}} til et utkast igjen",
          "promptTitle": "Gjør om {{label}} til utkast"
        },
        "unpublished": {
          "title": "Avpubliser",
          "description": "Avbryt og arkiver {{label}}",
          "promptTitle": "Avpubliser {{label}}"
        }
      }
    },
    "usable": {
      "title": "Publisert",
      "description": "{{label, capitalize}} er publisert",
      "transitions": {
        "draft": {
          "title": "Ny versjon",
          "description": "Fortsett å jobbe på en ny versjon av {{label}}",
          "promptTitle": "Ny versjon av {{label}}"
        },
        "unpublished": {
          "title": "Avpubliser",
          "description": "Avbryt publiseringen og arkiver {{label}}",
          "promptTitle": "Avpubliser {{label}}"
        }
      }
    },
    "withheld": {
      "title": "Planlagt",
      "description": "{{label, capitalize}} er planlagt for automatisk publisering",
      "transitions": {
        "usable": {
          "title": "Publiser direkte",
          "description": "Publiser {{label}} direkte",
          "promptTitle": "Publiser {{label}}"
        },
        "draft": {
          "title": "Til utkast",
          "description": "Avbryt planlagt publisering og gjør om til utkast igjen",
          "promptTitle": "Gjør om {{label}} til utkast"
        }
      }
    },
    "unpublished": {
      "title": "Avpublisert",
      "description": "{{label, capitalize}} har blitt avpublisert",
      "transitions": {
        "draft": {
          "title": "Ny versjon",
          "description": "Fortsett å jobbe på en ny versjon av {{label}}",
          "promptTitle": "Ny versjon av {{label}}"
        }
      }
    },
    "used": {
      "title": "Brukt",
      "description": "{{label, capitalize}} har blitt brukt til å avlede et nytt dokument",
      "transitions": {
        "draft": {
          "title": "Åpne som utkast",
          "description": "Tilbakestill {{label}} til utkast for videre redigering"
        }
      }
    }
  },
  "core/event": {
    "draft": {
      "title": "Utkast",
      "description": "Du jobber med et utkast av denne hendelsen",
      "transitions": {
        "done": {
          "title": "Bruk internt",
          "description": "Gjør hendelsen synlig internt"
        },
        "usable": {
          "title": "Publiser eksternt",
          "description": "Publiser hendelsen eksternt",
          "promptTitle": "Publiser hendelsen"
        }
      }
    },
    "done": {
      "title": "Intern",
      "description": "Hendelsen er synlig internt",
      "transitions": {
        "usable": {
          "title": "Publiser",
          "description": "Publiser hendelsen eksternt",
          "promptTitle": "Publiser hendelsen"
        },
        "unpublished": {
          "title": "Avpubliser",
          "description": "Avpubliser hendelsen",
          "promptTitle": "Avpubliser hendelsen"
        }
      }
    },
    "usable": {
      "title": "Publisert",
      "asSaveCTA": "Upubliserte endringer",
      "asSaveTitle": "Publiser ny versjon",
      "description": "Hendelsen er publisert eksternt",
      "changedDescription": "Hendelsen har blitt endret siden forrige publisering",
      "updateDescription": "Oppdater den publiserte hendelsen med de nye endringene",
      "transitions": {
        "unpublished": {
          "title": "Avpubliser",
          "description": "Avpubliser hendelsen eksternt",
          "promptTitle": "Avpubliser hendelsen"
        }
      }
    },
    "unpublished": {
      "title": "Avpublisert",
      "description": "Hendelsen har blitt avpublisert",
      "transitions": {
        "draft": {
          "title": "Utkast",
          "description": "Gjør om hendelsen til et utkast igjen",
          "promptTitle": "Gjør om hendelsen til utkast"
        }
      }
    }
  },
  "core/planning-item": {
    "draft": {
      "title": "Utkast",
      "description": "Du jobber med et utkast av denne planen",
      "transitions": {
        "done": {
          "title": "Bruk internt",
          "description": "Gjør planen synlig internt"
        },
        "usable": {
          "title": "Publiser eksternt",
          "description": "Publiser planen eksternt",
          "promptTitle": "Publiser planen"
        }
      }
    },
    "done": {
      "title": "Intern",
      "description": "Planen er synlig internt",
      "transitions": {
        "usable": {
          "title": "Publiser",
          "description": "Publiser planen eksternt",
          "promptTitle": "Publiser planen"
        },
        "unpublished": {
          "title": "Avpubliser",
          "description": "Avpubliser planen",
          "promptTitle": "Avpubliser planen"
        }
      }
    },
    "usable": {
      "title": "Publisert",
      "asSaveCTA": "Upubliserte endringer",
      "asSaveTitle": "Publiser endret versjon",
      "description": "Planen er publisert",
      "changedDescription": "Planen har blitt endret siden forrige publisering",
      "updateDescription": "Oppdater den publiserte planen med de nye endringene",
      "transitions": {
        "unpublished": {
          "title": "Avpubliser",
          "description": "Avpubliser planen eksternt",
          "promptTitle": "Avpubliser planen"
        }
      }
    },
    "unpublished": {
      "title": "Avpublisert",
      "description": "Planen har blitt avpublisert",
      "transitions": {
        "draft": {
          "title": "Utkast",
          "description": "Gjør om planen til et utkast igjen",
          "promptTitle": "Gjør om planen til utkast"
        }
      }
    }
  },
  "core/factbox": {
    "draft": {
      "title": "Utkast",
      "description": "Du jobber med et utkast av faktaboksen",
      "transitions": {
        "usable": {
          "verify": false,
          "title": "Publiser",
          "description": "Publiser faktaboksen"
        },
        "unpublished": {
          "verify": false,
          "title": "Kast",
          "description": "Fjern faktaboksen"
        }
      }
    },
    "usable": {
      "title": "Publisert",
      "asSaveCTA": "Endret",
      "asSaveTitle": "Oppdater",
      "description": "Faktaboksen er publisert",
      "updateDescription": "Publiser endringene",
      "transitions": {
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om faktaboksen til et utkast igjen"
        },
        "unpublished": {
          "verify": false,
          "title": "Kast",
          "description": "Fjern faktaboksen"
        }
      }
    },
    "unpublished": {
      "title": "Kastet",
      "description": "Faktaboksen er ikke synlig eller brukbar",
      "isWorkflow": false,
      "transitions": {
        "usable": {
          "verify": false,
          "title": "Publiser",
          "description": "Publiser faktaboksen"
        }
      }
    }
  },
  "core/editorial-info": {
    "draft": {
      "title": "Utkast",
      "description": "Du jobber med et utkast av denne informasjonen til redaksjonen",
      "transitions": {
        "done": {
          "title": "Legg klar",
          "description": "Legg som klar til redaksjonen",
          "promptTitle": "Legg klar redaksjonell info"
        },
        "approved": {
          "title": "Godkjenn",
          "description": "Godkjenn for intern bruk i redaksjonen",
          "promptTitle": "Godkjenn redaksjonell info"
        },
        "usable": {
          "title": "Publiser",
          "description": "Publiser slik at den er synlig eksternt",
          "promptTitle": "Publiser redaksjonell info"
        }
      }
    },
    "done": {
      "title": "Klar",
      "description": "Informasjonen er klar og venter på godkjenning",
      "transitions": {
        "approved": {
          "title": "Godkjenn",
          "description": "Godkjenn for intern bruk i redaksjonen",
          "promptTitle": "Godkjenn redaksjonell info"
        },
        "usable": {
          "title": "Publiser",
          "description": "Publiser slik at den er synlig eksternt",
          "promptTitle": "Publiser redaksjonell info"
        },
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om til et utkast igjen",
          "promptTitle": "Gjør om redaksjonell info til utkast"
        }
      }
    },
    "approved": {
      "title": "Intern",
      "description": "Informasjonen er publisert internt og kan publiseres eksternt",
      "transitions": {
        "usable": {
          "title": "Publiser",
          "description": "Publiser slik at den er synlig eksternt",
          "promptTitle": "Publiser redaksjonell info"
        },
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om til et utkast igjen",
          "promptTitle": "Gjør om redaksjonell info til utkast"
        }
      }
    },
    "usable": {
      "title": "Publisert",
      "description": "Informasjonen er publisert",
      "transitions": {
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om til et utkast igjen",
          "promptTitle": "Gjør om redaksjonell info til utkast"
        },
        "unpublished": {
          "title": "Trekk tilbake",
          "description": "Avbryt publiseringen og arkiver informasjonen",
          "promptTitle": "Trekk tilbake redaksjonell info"
        }
      }
    }
  },
  "tt/print-article": {
    "draft": {
      "title": "Utkast",
      "description": "Du jobber med et utkast av printartikkelen",
      "transitions": {
        "needs_proofreading": {
          "title": "Be om korrektur",
          "description": "Printartikkelen trenger korrektur",
          "promptTitle": "Be om korrektur av printartikkelen"
        },
        "print_done": {
          "title": "Legg klar",
          "description": "Marker printartikkelen som klar",
          "promptTitle": "Legg printartikkelen klar"
        },
        "usable": {
          "title": "Eksporter",
          "description": "Eksporter printartikkelen",
          "promptTitle": "Eksporter printartikkelen"
        }
      }
    },
    "needs_proofreading": {
      "title": "Klar for korrektur",
      "description": "Printartikkelen trenger korrektur",
      "transitions": {
        "print_done": {
          "title": "Legg klar",
          "description": "Marker printartikkelen som klar",
          "promptTitle": "Legg printartikkelen klar"
        },
        "usable": {
          "title": "Eksporter",
          "description": "Eksporter printartikkelen",
          "promptTitle": "Eksporter printartikkelen"
        },
        "cancelled": {
          "title": "Kast",
          "description": "Kast printartikkelen",
          "promptTitle": "Kast printartikkelen"
        },
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om printartikkelen til et utkast igjen",
          "promptTitle": "Gjør om printartikkelen til utkast"
        }
      }
    },
    "print_done": {
      "title": "Klar",
      "description": "Printartikkelen er klar og venter på godkjenning",
      "transitions": {
        "approved": {
          "title": "Godkjenn",
          "description": "Godkjenn printartikkelen",
          "promptTitle": "Godkjenn printartikkelen"
        },
        "usable": {
          "title": "Eksporter",
          "description": "Eksporter printartikkelen",
          "promptTitle": "Eksporter printartikkelen"
        },
        "needs_proofreading": {
          "title": "Be om korrektur",
          "description": "Printartikkelen trenger korrektur",
          "promptTitle": "Be om korrektur av printartikkelen"
        },
        "cancelled": {
          "title": "Kast",
          "description": "Kast printartikkelen",
          "promptTitle": "Kast printartikkelen"
        },
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om printartikkelen til et utkast igjen",
          "promptTitle": "Gjør om printartikkelen til utkast"
        }
      }
    },
    "usable": {
      "title": "Eksportert",
      "asSaveCTA": "Ueksporterte endringer",
      "asSaveTitle": "Eksporter endret versjon",
      "description": "Printartikkelen er eksportert",
      "changedDescription": "Printartikkelen er endret siden siste eksport",
      "updateDescription": "Oppdater den eksporterte printartikkelen med de nye endringene",
      "transitions": {
        "unpublished": {
          "title": "Trekk tilbake",
          "description": "Avbryt eksporten og arkiver printartikkelen",
          "promptTitle": "Trekk tilbake printartikkelen"
        }
      }
    },
    "unpublished": {
      "title": "Tilbaketrukket",
      "description": "Printartikkelen er avpublisert",
      "transitions": {
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om printartikkelen til et utkast igjen",
          "promptTitle": "Gjør om printartikkelen til utkast"
        }
      }
    },
    "cancelled": {
      "title": "Kastet",
      "description": "Printartikkelen er kastet",
      "transitions": {
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om printartikkelen til et utkast igjen",
          "promptTitle": "Gjør om printartikkelen til utkast"
        }
      }
    }
  },
  "core/article#timeless": {
    "article": "artikkelen",
    "flash": "flashen",
    "draft": {
      "title": "Utkast",
      "description": "Du jobber med et utkast av {{label}}",
      "transitions": {
        "done": {
          "title": "Legg klar",
          "description": "Legg {{label}} som klar"
        },
        "approved": {
          "title": "Godkjenn",
          "description": "Godkjenn {{label}} for publisering"
        },
        "usable": {
          "title": "Publiser",
          "description": "Publiser {{label}}"
        },
        "withheld": {
          "title": "Planlegg publisering",
          "description": "Angi tid for publisering. Flytt oppdrag/plan om en annen dato ønskes."
        }
      }
    },
    "done": {
      "title": "Klar",
      "description": "{{label, capitalize}} er klar og venter på godkjenning",
      "transitions": {
        "approved": {
          "title": "Godkjenn",
          "description": "Godkjenn {{label}} for publisering"
        },
        "usable": {
          "title": "Publiser",
          "description": "Publiser {{label}} direkte"
        },
        "withheld": {
          "title": "Planlegg publisering",
          "description": "Angi tid for publisering. Flytt oppdrag/plan om en annen dato ønskes."
        },
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om {{label}} til et utkast igjen"
        },
        "unpublished": {
          "title": "Avpubliser",
          "description": "Avbryt og arkiver {{label}}"
        }
      }
    },
    "approved": {
      "title": "Godkjent",
      "description": "{{label, capitalize}} er godkjent for publisering",
      "transitions": {
        "usable": {
          "title": "Publiser",
          "description": "Publiser {{label}}"
        },
        "withheld": {
          "title": "Planlegg publisering",
          "description": "Angi tid for publisering. Flytt oppdrag/plan om en annen dato ønskes."
        },
        "draft": {
          "title": "Til utkast",
          "description": "Gjør om {{label}} til et utkast igjen"
        },
        "unpublished": {
          "title": "Avpubliser",
          "description": "Avbryt og arkiver {{label}}"
        }
      }
    },
    "usable": {
      "title": "Publisert",
      "description": "{{label, capitalize}} er publisert",
      "transitions": {
        "draft": {
          "title": "Ny versjon",
          "description": "Fortsett å jobbe på en ny versjon av {{label}}"
        },
        "unpublished": {
          "title": "Avpubliser",
          "description": "Avbryt publiseringen og arkiver {{label}}"
        }
      }
    },
    "withheld": {
      "title": "Planlagt",
      "description": "{{label, capitalize}} er planlagt for automatisk publisering",
      "transitions": {
        "usable": {
          "title": "Publiser direkte",
          "description": "Publiser {{label}} direkte"
        },
        "draft": {
          "title": "Til utkast",
          "description": "Avbryt planlagt publisering og gjør om til utkast igjen"
        }
      }
    },
    "unpublished": {
      "title": "Avpublisert",
      "description": "{{label, capitalize}} har blitt avpublisert",
      "transitions": {
        "draft": {
          "title": "Ny versjon",
          "description": "Fortsett å jobbe på en ny versjon av {{label}}"
        }
      }
    }
  }
}
